import { getEnvironmentInfo } from '../utils/environment';

/**
 * Environment badge component that displays current environment
 * Only visible in non-production environments
 */
export function EnvironmentBadge() {
  const { name, isProduction } = getEnvironmentInfo();

  // Don't render in production or staging (only show in development)
  if (isProduction || name === 'staging') {
    return null;
  }

  const badgeStyles = {
    development: 'bg-blue-500 text-white',
    staging: 'bg-yellow-500 text-black',
    production: '' // Never shown
  };

  return (
    <div
      className={`fixed top-4 left-4 z-50 px-4 py-2 rounded-lg font-bold text-sm shadow-lg uppercase pointer-events-none ${badgeStyles[name]}`}
      data-testid="environment-badge"
      role="status"
      aria-label={`Current environment: ${name}`}
    >
      {name}
    </div>
  );
}
